<template>
  <div>
    <div v-if="page" class="row">
      <div class="col-12 col-md-8 col-lg-6">
        <card title="Create a new page">
          <form @submit.prevent="createPlace">
            <fieldset class="form-group">
              <label for="pageType">Select Page Type</label>
              <select
                id="pageType"
                class="form-control form-control-lg"
                type="text"
                placeholder="name"
                v-model="page.type"
                required
              >
                <option disabled value="">Select page type</option>
                <option
                  v-for="(type) in pageTypes"
                  :key="type"
                  :value="type"
                >
                  {{ type.replace('-', ' ') }}
                </option>
              </select>
            </fieldset>

            <fieldset class="form-group">
              <label for="pageName">Page Name</label>
              <input
                id="pageName"
                class="form-control form-control-lg"
                type="text"
                placeholder="name"
                v-model="page.heading.en"
                required
              />
            </fieldset>
            <fieldset class="form-group">
              <label>Page Description</label>
              <ck-editor v-model="page.description.en"></ck-editor>
            </fieldset>

            <fieldset class="form-group">
              <input
                class="btn btn-primary"
                type="submit"
                value="Create Page"
              />
            </fieldset>
          </form>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { PAGE_PUBLISH } from "@/store/actions.type";
import AssetPreviewBox from '@/components/AssetPreviewBox';
import CkEditor from '@/components/CKEditor';

export default {
  name: "CreatePage",

  components: {
    AssetPreviewBox,
    CkEditor
  },

  data() {
    return {
      page: null,

      pageTypes: [
        'place',
        'video',
        'card-grid',
      ]
    };
  },

  created () {
    this.fetchSchema()
  },

  methods: {
    createPlace() {
      this.$store.dispatch(PAGE_PUBLISH, this.page).then(res => {
        if (res.status === 200) {
          this.$router.push({
            name: "Edit page",
            params: { id: res.data.page._id }
          })
        }
      })
    },

    fetchSchema () {
      this.$store.dispatch('GET_PAGE_SCHEMA').then(res => {
        this.page = res.data
      })
    }
  }
}
</script>
